import React, { useState, useEffect } from "react";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Beranda", href: "#home" },
    { name: "Tentang Kami", href: "#about" },
    { name: "Layanan", href: "#services" },
    { name: "Galeri", href: "#gallery" },
    { name: "Kontak", href: "#contact" },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-700 ${
        isScrolled
          ? "bg-white/80 backdrop-blur-2xl shadow-2xl"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <a href="#home" className="relative group">
            <img
              src={
                isScrolled
                  ? "/assets/images/logo_warna.png"
                  : "/assets/images/logo_putih.png"
              }
              alt="BMX Logo"
              className="h-16 w-48 object-contain drop-shadow-2xl transition-all duration-500 group-hover:scale-105"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-10">
            {navLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className={`font-semibold text-sm uppercase tracking-wider transition-all duration-500 relative group ${
                  isScrolled
                    ? "text-gray-800 hover:text-primary"
                    : "text-white hover:text-white/80"
                }`}
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 gradient-primary group-hover:w-full transition-all duration-500"></span>
              </a>
            ))}

            {/* BUTTON - Putih/Hijau di Hero, Hijau/Putih saat Scroll */}
            <a
              href="#contact"
              className={`px-8 py-3.5 rounded-full font-bold text-sm uppercase tracking-wider btn-premium shadow-xl transition-all duration-500 ${
                isScrolled
                  ? "gradient-primary text-white"
                  : "bg-white text-primary"
              }`}
            >
              Hubungi Kami
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-3 rounded-xl transition-all duration-300 ${
              isScrolled ? "text-primary bg-gray-100" : "text-white bg-white/10"
            }`}
          >
            <svg
              className="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-700 ${
            isMobileMenuOpen
              ? "max-h-[500px] opacity-100 mb-6"
              : "max-h-0 opacity-0"
          }`}
        >
          <div className="py-6 space-y-4 glass-white rounded-3xl shadow-2xl">
            {navLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block px-6 py-3 text-gray-800 font-semibold hover:text-primary hover:bg-gradient-to-r hover:from-primary/5 hover:to-transparent rounded-2xl transition-all duration-300"
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block mx-6 px-6 py-3.5 text-center rounded-full gradient-primary text-white font-bold btn-premium shadow-xl"
            >
              Hubungi Kami
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
